


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Comp } from '../types';


/** Нестрогое сравнение значений (значение опции может быть объектом) */
const isSame = (a: unknown, b: unknown): boolean => {
    if (a === b) return true;
    if (a === null || b === null || a === undefined || b === undefined) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        return JSON.stringify(a) === JSON.stringify(b);
    }
    return String(a) === String(b);
};


/**
 * Выпадающий список «код - название» с обрезанными текстами опций.
 * Полное название - в title опции, title select'а и под полем.
 */
@Component
export default class CodeNameSelect extends Vue {
    @Prop({ required: false, default: null })
    public readonly value!: unknown;

    @Prop({ type: Array, required: true })
    public readonly options!: Array<Comp.DropdownItemDef<unknown>>;

    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean;

    @Prop({ type: String, required: false, default: null })
    public readonly id!: string | null;

    /** Стиль самого select'а (например, размер шрифта) */
    @Prop({ type: [String, Object], required: false, default: null })
    public readonly selectStyle!: string | Record<string, string> | null;

    /** Выбранная опция (null - если значение пустое или не найдено) */
    private get selectedOption(): Comp.DropdownItemDef<unknown> | null {
        if (this.value === null || this.value === undefined) return null;
        return this.options.find(o => isSame(o.value, this.value)) ?? null;
    }

    /** Полное название выбранного значения ('' - если значение пустое) */
    private get selectedTitle(): string {
        const option = this.selectedOption;
        if (option === null) return '';
        return option.title ?? option.text;
    }

    /** Текст выбранной опции обрезан - полное название показывается под полем */
    private get isSelectedTruncated(): boolean {
        const option = this.selectedOption;
        return option !== null && option.title !== undefined && option.title !== option.text;
    }

    private onInput(value: unknown) {
        this.$emit('input', value);
    }

    private onChange(value: unknown) {
        this.$emit('change', value);
    }
}
